type DecimalStringValue = string | null | undefined;

export const normalizeDecimalString = (
  value: DecimalStringValue
): DecimalStringValue | null => {
  if (value?.trim().length === 0) {
    return null;
  }

  return value;
};

export const normalizeDecimalStrings = (
  data: Record<string, unknown>,
  fields: readonly string[]
): Record<string, unknown> => {
  const normalized = { ...data };

  for (const field of fields) {
    const value = normalized[field];
    if (typeof value === 'string' || value === null || value === undefined) {
      normalized[field] = normalizeDecimalString(value);
    }
  }

  return normalized;
};
